import { render } from "./FormText.vue?vue&type=template&id=165be605&scoped=true&ts=true"
import script from "./FormText.vue?vue&type=script&lang=ts"
export * from "./FormText.vue?vue&type=script&lang=ts"

import "./FormText.vue?vue&type=style&index=0&id=165be605&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-165be605"]])

export default __exports__